module.exports = __webpack_public_path__ + "assets/2947bc1e232e2cebbad00e78a6c83d3f.eot";